<div class="row" *ngIf="list.length > 0">
    <div class="col-12">
        <ul class="listaFollow">
            <li class="followItem" *ngFor="let f of list">
                <app-small-profile-item [id]="f"></app-small-profile-item>
            </li>
        </ul>
    </div>
</div>